module.exports = __webpack_public_path__ + "img/qianbao_bg.d59149cc.png";